import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import React from 'react'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import Button from '../Button'
import type { ButtonProps } from '../Button'
import Typography from '../Typography'

const useStyles = makeStyles<Theme, ButtonProps>((theme) => ({
  root: {},
  buttonRoot: {
    color: theme.paintscout.palette.brand.Neutral.P50
  },
  text: {
    fontFamily: 'euclid'
  },
  backLink: {
    paddingRight: 0,
    color: theme.paintscout.palette.brand.Neutral.P50,
    '& svg': {
      fontSize: '1em !important'
    },
    '@media print': {
      display: 'none'
    }
  }
}))

export interface BackButtonProps extends ButtonProps {
  children?: React.ReactNode
}

const BackButton = ({ children = <>Back</>, ...props }) => {
  const classes = useStyles(props)

  return (
    <Button
      {...props}
      variant="text"
      size="small"
      className={classes.buttonRoot}
      startIcon={<ArrowBackIos classes={{ root: classes.backLink }} />}
      classes={classes}
    >
      <Typography variant="overline" className={classes.text}>
        {children}
      </Typography>
    </Button>
  )
}

export default BackButton
